"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var types_1 = require("../../middleware/api/types");
var api_1 = require("../../utils/api");
var config_1 = __importStar(require("../../config"));
var constants_1 = require("./constants");
var getConfig_1 = __importDefault(require("./queries/getConfig"));
var getConfigCommercial_1 = __importDefault(require("./queries/getConfigCommercial"));
exports.setAccessToken = function (accessToken) { return toolkit_1.createAction(constants_1.SET_ACCESS_TOKEN)(accessToken); };
exports.setUser = function (user) { return toolkit_1.createAction(constants_1.SET_USER)(user); };
exports.unauthorizedError = function (error) { return toolkit_1.createAction(constants_1.UNAUTHORIZED_ERROR)(error); };
exports.linkAccount = function (idToken) {
    return api_1.createApiAction(constants_1.LINK_ACCOUNT, {
        baseURL: config_1.default.EXP_API_URL,
        method: types_1.HTTPMethod.PUT,
        path: '/auth/linkAccount',
        data: { secondaryUserIdToken: idToken },
        authenticated: true,
    });
};
exports.optOut = function (accountId) {
    return api_1.createApiAction(constants_1.OPT_OUT, {
        baseURL: config_1.default.EXP_API_URL,
        method: types_1.HTTPMethod.DELETE,
        // need to escape the | character here otherwise cors preflight request will fail in Firefox:
        path: "/auth/newSkyGo/" + encodeURIComponent(accountId),
        data: null,
        authenticated: true,
    });
};
exports.fetchConfig = function (appId) {
    return api_1.createApiAction(constants_1.FETCH_CONFIG, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getConfig_1.default,
            variables: { appId: appId },
        },
        graphQL: true,
    });
};
exports.fetchConfigCommercial = function (appId) {
    return api_1.createApiAction(constants_1.FETCH_CONFIG, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getConfigCommercial_1.default,
            variables: { appId: appId },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.setAuthLoading = function (isLoading) {
    return toolkit_1.createAction(constants_1.SET_AUTH_LOADING)(isLoading);
};
//# sourceMappingURL=actions.js.map